import { MessageBox } from "element-react";
import React, { Component } from "react";
import {
  Redirect,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";

// 모든 페이지에 적용해야하기 때문에 AuthenticatedRoute를 감싸는 Provider 컴포넌트로 사용
// 웹소켓 사용하거나 페이지 이동 시마다 체크

class FireDetection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: {
        id: 0,
        type: "",
        isConfirm: false,
      },
    };
  }

  componentDidMount() {
    // this.fetchFireAlert();
  }

  componentDidUpdate() {
    // setTimeout(() => {
    //   this.alert();
    // }, 500);
  }

  alert() {
    const { alertMessage } = this.state;

    if (alertMessage.type === "detection" && !alertMessage.isConfirm) {
      this.fireDetection();
    } else if (alertMessage.type === "risk" && !alertMessage.isConfirm) {
      this.fireRisk();
    }
  }

  fireDetection() {
    MessageBox.alert(
      "화재 발생! 현장 확인 및 전체 모듈 전원을 꺼주세요.",
      "알림",
      {
        confirmButtonText: "해당 발전소로 이동",
        type: "warning",
        showClose: true,
        showConfirmButton: true,
        showCancelButton: false,
        closeOnClickModal: true,
        closeOnPressEscape: false,
      }
    ).then(() => {
      this.movePlantDetail()
    })
    .catch((error) => {
        console.error("Fetch Error: ", error);
    });
  }

  fireRisk() {
    MessageBox.alert(
      "화재 위험도가 높은 시설이 확인되었습니다. 현장 확인 및 모니터링을 체크해주세요.",
      "알림",
      {
        confirmButtonText: "해당 발전소로 이동",
        type: "warning",
        showClose: true,
        showConfirmButton: true,
        showCancelButton: false,
        closeOnClickModal: true,
        closeOnPressEscape: false,
        confirmButtonClass: "confirm-btn-w-full"
      }
    );
  }

  fetchFireAlert() {
    // 화재감지 정보를 fetch
    setTimeout(() => {
      this.addAlert({
        id: 28,
        type: "detection",
      });
    }, 200);
  }

  movePlantDetail() {
    const { alertMessage } = this.state;
    this.removeAlert();
    // TODO: projectId 추가하기
    this.props.history.push(`/plant-list/solar/detail/${alertMessage.id}`);
  }

  addAlert(data) {
    // 화재감지 정보를 등록
    const alertMessage = {
      id: data.id,
      type: data.type,
      isConfirm: false,
    };

    this.setState({ alertMessage });
  }

  removeAlert() {
    // 등록된 화재감지 정보를 제거
    this.setState({
      alertMessage: {
        id: 0,
        type: "",
        isConfirm: true,
      },
    });
  }

  render() {
    return (
      <>
        {this.props.children}
        {/* 필요의 경우 modal 제작 후 넣기 */}
      </>
    );
  }
}

export default withRouter(FireDetection);
